module.exports = __webpack_public_path__ + "static/media/05.e0c65bad.mp3";